var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04134 26.21C3.15957 27.3549 3.91016 28.2611 5.03585 28.5007C6.81269 28.879 10.1621 29.3334 16 29.3334C21.8379 29.3334 25.1873 28.879 26.9642 28.5007C28.0899 28.2611 28.8405 27.3549 28.9587 26.21C29.134 24.5126 29.3334 21.396 29.3334 16C29.3334 10.6041 29.134 7.4875 28.9587 5.79006C28.8405 4.64523 28.0899 3.73903 26.9642 3.49938C25.1873 3.12112 21.8379 2.66671 16 2.66671C10.1621 2.66671 6.81269 3.12112 5.03585 3.49938C3.91016 3.73903 3.15957 4.64523 3.04134 5.79006C2.86604 7.4875 2.66669 10.6041 2.66669 16C2.66669 21.396 2.86604 24.5126 3.04134 26.21Z",
    fill: "#194C81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5849 18.4745C20.3513 17.5443 21.5556 15.6906 21.5556 13.5556C21.5556 10.4873 19.0683 8 16.0001 8C12.9318 8 10.4445 10.4873 10.4445 13.5556C10.4445 15.6907 11.649 17.5445 13.4155 18.4746C11.0498 19.3759 9.24351 21.4789 8.68399 24.0705C8.60655 24.4292 8.80392 24.7974 9.16517 24.8628C10.4617 25.0974 12.6088 25.3333 16.0014 25.3333C19.394 25.3333 21.5411 25.0974 22.8376 24.8628C23.1976 24.7977 23.3944 24.4309 23.3174 24.0735C22.7586 21.4804 20.9516 19.376 18.5849 18.4745Z",
    fill: "#B6DDF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/totalUsers.23ec05ac17062b32898ce0c134908c7e.svg";
export { ForwardRef as ReactComponent };